<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    cancelText="关闭">
    <doctor-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></doctor-form>
    <doctot-goob-modal ref="doctorGoobModal"></doctot-goob-modal>
  </j-modal>
</template>

<script>

  import DoctorForm from './DoctorForm'
  import DoctorGoobModal from '@/views/doctor/modules/DoctorGoobModal'

  export default {
    name: 'DoctorModal',
    components: {
      DoctorForm,
      DoctorGoobModal

    },
    data () {
      return {
        title:'',
        width:896,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>